import { LOGIN_LIMIT_ACTION_TYPE } from "./login-limit.action";

export const LOGIN_LIMIT_MESSAGE_CONTEXT = {
	get: LOGIN_LIMIT_ACTION_TYPE.get,
	update: LOGIN_LIMIT_ACTION_TYPE.update,
	remove: LOGIN_LIMIT_ACTION_TYPE.remove,
};

export const LOGIN_LIMIT_MESSAGE_CODE = {
	getError: "M_LOGIN_LIMIT_GET_ERROR",
	updateSuccess: "M_LOGIN_LIMIT_UPDATE_SUCCESS",
	updateError: "M_LOGIN_LIMIT_UPDATE_ERROR",
	removeSuccess: "M_LOGIN_LIMIT_REMOVE_SUCCESS",
	removeError: "M_LOGIN_LIMIT_REMOVE_ERROR",
};
